(function ($) {
	$.fn.heroShapeResize = function () {
		const calculateShapeWidth = (vHeight, $shape) => {
			const percentage = Number((parseFloat( (parseFloat($shape.css('padding-bottom')) * 100) / parseFloat($shape.css('width')) )).toFixed(2));
			const newWidth = Number((parseFloat(vHeight) * 100) / parseFloat(percentage)).toFixed(2);
			return newWidth;
		}

		const calculateRightPadding = ($contentWrapper, originalHeroShapeWidth, shapeWidth) => {
			const $bottomContainer = $contentWrapper.find('.bottom-container');
			
			//reset
			$bottomContainer.css('padding-right', '');

			//calculate
			const calculatedPadding = (shapeWidth *  parseFloat($bottomContainer.css('padding-right')).toFixed(2)) / originalHeroShapeWidth;

			//set
			$bottomContainer.css('padding-right', calculatedPadding + 'px');
		}

		const initResize = (doResize) => {
			$(window).on('resize fr:pseudo-resize', (e) => {
				doResize();
			});

			//on page load
			$(window).trigger('fr:pseudo-resize');
		}

		return this.each((i, el) => {
			const $self = $(el);
			const $contentWrapper = $self.find('.content-wrapper');
			const $heroShape = $self.find('.hero-shape-1-container > div');
			const originalHeroShapeWidth = $heroShape.width();

			const doResize = $.fn.debounce(function() {
				$heroShape.css('width', '');
				let innerHeight = 0;
	
				$.each($contentWrapper.find('> div:not(.hero-tag)'), (i, el) =>  { 
					innerHeight += $(el).outerHeight(true);
				});

				if(innerHeight > $heroShape.innerHeight()){
					const shapeWidth = calculateShapeWidth(innerHeight, $heroShape);
					$heroShape.css('width', shapeWidth + 'px');
					calculateRightPadding($contentWrapper, originalHeroShapeWidth, shapeWidth);
				}
			}, 150);
			

			if(!window.frFontsLoaded){
				$(window).on('fr:fonts-loaded', () => {
					initResize(doResize);
				});
			}else{
				initResize(doResize);
			}
		});
	}

	$(() => {
		$('.fr-hero:is(.topic-hero, .strategy-hero, .case-study-hero, .resource-hero)').heroShapeResize();
	});
})(jQuery);